var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictogramLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 57,
    viewBox: "0 0 42 57",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 1.25l31.44.77 7.87 9.17V55H1.78z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "brandable",
    d: "M6.77 7.3h20.36v14.22H6.77z",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "brandable",
    d: "M41.54 10.16L32 .77a.74.74 0 0 0-.51-.21H1.06a.72.72 0 0 0-.73.71v54.46a.72.72 0 0 0 .73.71H41a.71.71 0 0 0 .72-.71V10.66a.69.69 0 0 0-.18-.5zm-9.1-6.38l.4-.16 5.8 5.75-.16.4h-6.05v-6zM40.3 55H1.78V2h29v8.68a.71.71 0 0 0 .72.71h8.8V55zM6.24 48.65a.83.83 0 1 1 0-1.65H21.3a.83.83 0 1 1 0 1.65H6.24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "brandable",
    d: "M6.24 44.6a.83.83 0 1 1 0-1.65H21.3a.83.83 0 1 1 0 1.65H6.24zm.1-3.85a.83.83 0 1 1 0-1.65h7.53a.83.83 0 1 1 0 1.65H6.34zm19.8-18.45H7.87a1.21 1.21 0 0 1-1.21-1.2V8a1.21 1.21 0 0 1 1.21-1.2h18.26A1.21 1.21 0 0 1 27.34 8v13.1a1.21 1.21 0 0 1-1.21 1.2zm-18-1.5h17.7V8.28H8.16L8.13 20.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramLabel);
export default __webpack_public_path__ + "static/media/pictogram-label.573b42dcda3e64a1c13d6b5ddc2c4a74.svg";
export { ForwardRef as ReactComponent };